import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/firestore';
import 'firebase/storage';
import moment from 'moment-timezone';
const axios = require('axios').default;

const TENANT_ID = 'connextcc';
const API_BASE = 'https://api.connextcc.cc';

export default {
  data() {
    return { paybridge: false, paybridgeChecking: false, paybridgeCancelling: false, paybridgeMatch: null, paybridgeLocalDepositId: '', paybridgeAcknowledged: false, paybridgeNow: Date.now(), paybridgeTaskTimer: null, paybridgeExpiredNotified: false };
  },
  computed: {
    hasActivePayBridgeTask() { return !!this.paybridgeMatch && !this.isPayBridgeTaskExpired(); },
    paybridgeTaskRemainingSeconds() {
      if (!this.paybridgeMatch || !this.paybridgeMatch.expiresAt) return 0;
      const expiresAtMs = Date.parse(this.paybridgeMatch.expiresAt);
      return expiresAtMs ? Math.max(0, Math.ceil((expiresAtMs - this.paybridgeNow) / 1000)) : 0;
    },
    paybridgeTaskRemainingText() {
      const remaining = this.paybridgeTaskRemainingSeconds;
      return remaining ? `${Math.floor(remaining / 60)}:${String(remaining % 60).padStart(2, '0')}` : '';
    },
    paybridgeDisplayAmount() { return Number(this.paybridgeMatch?.amountMinor || 0) / 100 || Number(this.depositAmount || this.inputDepositAmount || 0); },
  },
  mounted() {
    this.restorePayBridgeTask();
    this.paybridgeTaskTimer = window.setInterval(() => { this.paybridgeNow = Date.now(); this.expirePayBridgeTaskIfNeeded(); }, 1000);
  },
  beforeDestroy() { if (this.paybridgeTaskTimer) window.clearInterval(this.paybridgeTaskTimer); },
  methods: {
    getPayBridgeTaskStorageKey() { return `${TENANT_ID}_paybridge_task_${this.user?.key || 'guest'}`; },
    isPayBridgeTaskExpired(match = this.paybridgeMatch) { const expiresAtMs = match?.expiresAt ? Date.parse(match.expiresAt) : 0; return !!expiresAtMs && expiresAtMs <= this.paybridgeNow; },
    persistPayBridgeTask() {
      if (!this.paybridgeMatch || this.isPayBridgeTaskExpired()) return;
      localStorage.setItem(this.getPayBridgeTaskStorageKey(), JSON.stringify({ match: this.paybridgeMatch, localDepositId: this.paybridgeLocalDepositId, acknowledged: this.paybridgeAcknowledged }));
    },
    restorePayBridgeTask() {
      try {
        const payload = JSON.parse(localStorage.getItem(this.getPayBridgeTaskStorageKey()) || 'null');
        if (!payload?.match || this.isPayBridgeTaskExpired(payload.match)) { localStorage.removeItem(this.getPayBridgeTaskStorageKey()); return false; }
        this.paybridgeMatch = payload.match; this.paybridgeLocalDepositId = payload.localDepositId || ''; this.paybridgeAcknowledged = !!payload.acknowledged; this.paybridgeExpiredNotified = false;
        return true;
      } catch (error) { localStorage.removeItem(this.getPayBridgeTaskStorageKey()); return false; }
    },
    clearPayBridgeTask() { localStorage.removeItem(this.getPayBridgeTaskStorageKey()); this.paybridgeMatch = null; this.paybridgeLocalDepositId = ''; this.paybridgeAcknowledged = false; this.paybridgeExpiredNotified = false; },
    expirePayBridgeTaskIfNeeded() {
      if (!this.paybridgeMatch || !this.isPayBridgeTaskExpired()) return;
      this.clearPayBridgeTask();
      if (!this.paybridgeExpiredNotified) { this.paybridgeExpiredNotified = true; this.$swal({ icon: 'warning', title: 'PayBridge หมดเวลา', text: 'ห้ามโอนเข้าบัญชีเดิม กรุณาเริ่มฝากใหม่อีกครั้ง' }); }
    },
    reopenPayBridgeTask() {
      if (!this.hasActivePayBridgeTask && !this.restorePayBridgeTask()) return;
      this.depositAmount = this.paybridgeDisplayAmount;
      window.$('#depositModal').modal('show');
    },
    acknowledgePayBridgeTerms() { this.paybridgeAcknowledged = true; this.persistPayBridgeTask(); },
    async cancelPayBridgeTask(options = {}) {
      if (this.paybridgeCancelling) return false;
      if (!options.skipConfirmation) {
        const answer = await this.$swal({ icon: 'warning', title: 'ยกเลิกรายการ PayBridge?', text: 'หากยกเลิก ห้ามโอนไปบัญชีที่แสดงไว้', showCancelButton: true, confirmButtonText: 'ยกเลิก', cancelButtonText: 'ทำรายการต่อ' });
        if (!answer.isConfirmed && !answer.value) return;
      }
      this.paybridgeCancelling = true;
      if (this.paybridgeLocalDepositId && this.user?.key) {
        try {
          const response = await axios.post(API_BASE + '/paybridge/deposit/cancel', {
            localDepositId: this.paybridgeLocalDepositId,
            userKey: this.user.key,
            reason: 'CUSTOMER_CANCELLED',
          }, { timeout: 15000 });
          const result = response.data || {};
          if (!result.ok) throw new Error(result.error || 'ไม่สามารถยกเลิกรายการ PayBridge ได้');
          if (result.alreadyCompleted && this.$swal) {
            await this.$swal({ icon: 'info', title: 'รายการฝากเดิมสำเร็จแล้ว', text: 'ระบบได้รับยอดฝากของรายการเดิมแล้ว' });
          }
        } catch (error) {
          console.warn('PayBridge cancel failed:', error?.message || error);
          if (this.$swal) {
            await this.$swal({ icon: 'error', title: 'ยังไม่สามารถสร้างรายการใหม่ได้', text: 'ระบบปิดรายการ PayBridge เดิมไม่สำเร็จ กรุณาลองอีกครั้ง' });
          }
          this.paybridgeCancelling = false;
          return false;
        }
      }
      this.clearPayBridgeTask(); this.depositAmount = null; this.assignedBank = null; this.inputDepositAmount = null;
      this.paybridgeCancelling = false;
      if (!options.skipConfirmation) window.$('#depositModal').modal('hide');
      return true;
    },
    getPayBridgeBankImage(bankCode) { return this.getBankImage(bankCode === 'BBL' ? 'bankokbank' : bankCode === 'BAY' ? 'krungsri' : String(bankCode || '').toLowerCase()); },
    async loadPayBridgePublicConfig() {
      try {
        const snapshot = await firebase.database().ref('/paybridge/public').once('value');
        return snapshot.val() || {};
      } catch (error) {
        console.warn('PayBridge public config unavailable; using existing deposit provider');
        return { enabled: false };
      }
    },
    async tryPayBridgeDeposit(selectedAccount) {
      if (String(selectedAccount?.bank || '').toLowerCase() === 'truewallet') return false;
      this.paybridgeChecking = true;
      try {
        const config = await this.loadPayBridgePublicConfig();
        this.paybridge = config.enabled === true;
        if (!this.paybridge) return false;
        const amount = Number(this.inputDepositAmount || 0);
        const bonusRequested = this.getDepositBonusRequested();
        const localDepositId = `deposit-${this.user.key}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        const response = await axios.post(API_BASE + '/paybridge/deposit/check', { localDepositId, amount, userKey: this.user.key, code: this.user.code || '', bonus: bonusRequested, customerAccount: { bank: selectedAccount.bank || '', account_no: selectedAccount.account_no || '', firstname: selectedAccount.firstname || this.user.firstname || '', lastname: selectedAccount.lastname || this.user.lastname || '' } }, { timeout: 15000 });
        const result = response.data || {};
        if (result.action !== 'PAY_BRIDGE_RECIPIENT' || !result.matchId || !result.recipientAccount) return false;
        this.paybridgeLocalDepositId = result.localDepositId || localDepositId; this.paybridgeMatch = { ...result, bonus_requested: bonusRequested }; this.paybridgeAcknowledged = false; this.depositAmount = amount; this.assignedBank = null; this.persistPayBridgeTask();
        return true;
      } catch (error) { console.warn('PayBridge check failed; using existing deposit provider', error?.message || error); return false; }
      finally { this.paybridgeChecking = false; }
    },
    async uploadPayBridgeSlip(event) {
      const image = event?.target?.files?.[0];
      if (!image || !this.paybridgeMatch || this.isPayBridgeTaskExpired()) return;
      this.$store.commit('user/SET_LOADING', true);
      let slipRef;
      try {
        const pending = await firebase.firestore().collection('slip').where('userkey', '==', this.user.key).where('status', '==', 'กำลังดำเนินการ').limit(1).get();
        if (!pending.empty) throw new Error('มีสลิปที่กำลังตรวจสอบอยู่ กรุณารอรายการเดิมก่อน');
        const account = this.currentDepositAccount || this.selectedDepositAccount || this.getApprovedAccounts()[0] || {};
        const resized = await this.resizeImage(image, 800, 800);
        const match = this.paybridgeMatch;
        const recipientAccount = match.recipientAccount || {};
        const bonusRequested = this.getDepositBonusRequested();
        slipRef = await firebase.firestore().collection('slip').add({ userkey: this.user.key, code: this.user.code || '', bonus_requested: bonusRequested, bonus_request_source: 'deposit_request', user: { code: this.user.code || '', firstname: account.firstname || this.user.firstname || '', lastname: account.lastname || this.user.lastname || '', bank: account.bank || '', account_no: account.account_no || '', bonus: bonusRequested }, status: 'กำลังดำเนินการ', provider: 'paybridge', created_at: firebase.firestore.FieldValue.serverTimestamp(), createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'), paybridge_match_id: match.matchId, paybridge_deposit_id: match.depositId || '', paybridge_withdrawal_id: match.withdrawalId || '', paybridge_local_deposit_id: this.paybridgeLocalDepositId, paybridge_amount_minor: match.amountMinor || Math.round(this.paybridgeDisplayAmount * 100), paybridge_recipient_account: recipientAccount });
        const extension = String(image.name || 'slip.jpg').split('.').pop();
        const storagePath = `images/slip/paybridge/${slipRef.id}.${extension}`;
        const task = firebase.storage().ref(storagePath).put(resized);
        const snapshot = await task;
        const imageUrl = await snapshot.ref.getDownloadURL();
        await slipRef.update({ image: imageUrl, slip_storage_path: storagePath });
        const response = await axios.post(API_BASE + '/paybridge/slip/submit', { matchId: match.matchId, slipStoragePath: storagePath, slipImageUrl: imageUrl, slipId: slipRef.id, localDepositId: this.paybridgeLocalDepositId }, { timeout: 20000 });
        await slipRef.update({ paybridge_submitted: true, paybridge_submit_status: response.data?.status || '', paybridge_verification_id: response.data?.verificationId || '', paybridge_submitted_at: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss') });
        this.clearPayBridgeTask();
        window.$('#depositModal').modal('hide');
        await this.$swal({ icon: 'success', title: 'ส่งสลิปแล้ว', text: 'ระบบกำลังตรวจสอบสลิปและจะเติมเครดิตให้อัตโนมัติ' });
      } catch (error) {
        if (slipRef) await slipRef.set({ paybridge_submit_error: error?.message || 'PayBridge submit failed', paybridge_submit_error_at: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss') }, { merge: true });
        await this.$swal({ icon: 'error', title: 'ส่งสลิปไม่สำเร็จ', text: error?.response?.data?.error || error?.message || 'กรุณาลองใหม่' });
      } finally { this.$store.commit('user/SET_LOADING', false); if (event?.target) event.target.value = ''; }
    },
  },
};
